import styled from 'styled-components';
import { eventApi } from '../../../core/api/rtk-query/event.api';

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(13, 25, 41, 0.36);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Modal = styled.div`
  width: 900px;
  max-width: calc(100% - 24px);
  max-height: calc(100vh - 48px);
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  overflow-y: auto;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #0b1221;
`;

const CloseBtn = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #667085;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  &:hover {
    background: #f0f0f0;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`;

const Th = styled.th`
  text-align: left;
  padding: 12px;
  background: #f7f9ff;
  border-bottom: 2px solid #dbe3f6;
  font-weight: 600;
  color: #0b1221;
`;

const Td = styled.td`
  padding: 12px;
  border-bottom: 1px solid #e5e8f0;
  color: #667085;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #667085;
  font-size: 15px;
`;

interface EventResultsModalProps {
  eventId: string;
  onClose: () => void;
}

export const EventResultsModal = ({ eventId, onClose }: EventResultsModalProps) => {
  const { data: eventData } = eventApi.useGetEventQuery(eventId);
  const { data: usersData } = eventApi.useGetUsersInEventQuery({ eventId, pageNumber: 1, pageSize: 1000 });

  return (
    <Backdrop onClick={onClose}>
      <Modal onClick={e => e.stopPropagation()}>
        <Header>
          <Title>Результаты: {eventData?.name || 'Загрузка...'}</Title>
          <CloseBtn onClick={onClose}>✕</CloseBtn>
        </Header>

        {usersData && usersData.users.length > 0 ? (
          <Table>
            <thead>
              <tr>
                <Th>Студент</Th>
                <Th>Email</Th>
                <Th>ISU</Th>
                <Th>Баллы</Th>
                <Th>Статус</Th>
              </tr>
            </thead>
            <tbody>
              {usersData.users.map((user: any) => (
                <tr key={user.id}>
                  <Td>{user.name || 'Не указано'}</Td>
                  <Td>{user.email}</Td>
                  <Td>{user.isuNumber || '-'}</Td>
                  <Td>{user.points !== undefined ? user.points : '-'}</Td>
                  <Td>
                    {user.points >= (eventData?.minimumPointsToPass || 0) ? (
                      <span style={{ color: '#2e7d32', fontWeight: 600 }}>Пройдено</span>
                    ) : (
                      <span style={{ color: '#d32f2f', fontWeight: 600 }}>Не пройдено</span>
                    )}
                  </Td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <EmptyState>Нет данных о студентах</EmptyState>
        )}
      </Modal>
    </Backdrop>
  );
};
